export default __webpack_public_path__ + "images/ff356ff8f1ced13e3ea2665570fd926d-YGP_citybrowseheader_DC_791x488px@2x.webp";